<p>
  register-schedule works!
</p>
